import styles from '../../css/InfoPress.module.css';
import { useEffect, useState } from 'react';
import { useTranslation
 } from 'react-i18next';
const InfoPress = () => {

  const { t } = useTranslation("global");

    const [data, setData] = useState(null); // State variable to hold fetched data

  useEffect(() => {
    const fetchDataFromFirebase = async () => {
      try {
        const firebaseUrl = `https://bbdesign-415904-default-rtdb.europe-west1.firebasedatabase.app/press.json`;
        const response = await fetch(firebaseUrl);

        if (!response.ok) {
          throw new Error('Network response was not ok. Status: ' + response.status);
        }

        const jsonData = await response.json();
        setData(jsonData); // Set the fetched data into state
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchDataFromFirebase(); // Fetch data when the component mounts
  }, []);

  // If data is null or not an object, return null or an error message
  if (!data || typeof data !== 'object') {
    return <p>Loading</p>; // Return an error message
  }

  // Get the keys of the object
  const keys = Object.keys(data);

  // Render the JSX with the fetched data
  return <>
        <div className={styles.press}>
            <h2>{t("infoPress.title")}</h2>
            <div className={styles.grid}>
            {keys.map((key, index) => ( // Iterate over the keys of the object
            <div key={index}>
              {data[key].map((item, subIndex) => ( // Map over the array associated with each key
                <div key={subIndex} className={styles.column}>
                  <p>{item}</p>
                </div>
              ))}
            </div>
          ))}
            </div>
        </div>
    </>
    
}

export default InfoPress